import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import {Magazzino} from "../_Models/magazzino";
import {Permission} from "../../Login/_guards/Permission";
import {CampoUtility} from "../../shared/models/campo-aggiuntivo";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ApiPathsService} from "../../api-paths.service";

@Component({
  selector: 'app-magazzino',
  templateUrl: './magazzino.component.html'
})
export class MagazzinoComponent implements OnInit {
  @Input() Tipo: string;//route be
  @Input() Item: Magazzino;
  @Input() IsModal: boolean = true;
  environment = environment;
  Stampe: any[];

  constructor(
    public permission: Permission,
    public campoUtility: CampoUtility,
    private ngbActiveModal: NgbActiveModal,
    private apiPathsService: ApiPathsService
  ) { }

  ngOnInit(): void {
    this.Refresh();
  }


  ButtonClick(button: any) {

  }

  Close() {
    this.ngbActiveModal.dismiss();
  }
  Save(close?: boolean){
    this.apiPathsService.ClassicPost(`/prodotti/${this.Tipo}/${this.Item.id? 'update' : 'add'}`, this.Item).subscribe(data => {
      if(!this.Item.id)
        this.Item = data;
      this.Refresh();
        if (close)
          this.Close();
    });
  }

  private Refresh() {
    if(this.Item?.id)
      this.apiPathsService.ClassicPost(`/prodotti/${this.Tipo}/get`, {id: this.Item.id}).subscribe(data => {
        this.Item = data.data;
        this.Stampe = data.stampe;

      });
  }
  ChangeHandler(item: { OnChange: string; Event: any }){
    console.log("ChangeHandler", item);
    switch (item.OnChange){
      case 'Assegna':
        if(item.Event)  {
          this.apiPathsService.ClassicPost(`/prodotti/${this.Tipo}/assegnazioni/add`, {persona_id: item.Event.id, furgone_id: this.Item.id}).subscribe(data => {
            this.Refresh();
            this.apiPathsService.ClassicPost(`/prodotti/${this.Tipo}/assegnazioni/list`, {page:0, size:10,id: this.Item.id}).subscribe(data => {
              var array = data.data;
              if (array.length>1)
                array[0].first = true;
              this.Item['assegnazioni'] = array;
            });
          });
          setTimeout(()=>{this.Item['addassegnazione'] = null;}, 300)
        }
        break;
      case 'OnSgancia':
        if(item.Event)  {
          this.apiPathsService.ClassicPost(`/prodotti/${this.Tipo}/assegnazioni/add`, {persona_id: item.Event.persona_id, furgone_id: this.Item.id}).subscribe(data => {
            this.Refresh();
            this.apiPathsService.ClassicPost(`/prodotti/${this.Tipo}/assegnazioni/list`, {page:0, size:10,id: this.Item.id}).subscribe(data => {
              var array = data.data;
              if (array.length>1)
                array[0].first = true;
              this.Item['assegnazioni'] = array;
            });
          });
        }
        break;
      case 'movimentazioneAdd':

        break;
    }
  }
}
